var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "BaginProcess"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Bagging")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2 radio"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedType),
      expression: "checkedType"
    }],
    attrs: {
      "type": "radio",
      "name": "bagging",
      "id": "bagging",
      "value": "bagging"
    },
    domProps: {
      "checked": _vm._q(_vm.checkedType, "bagging")
    },
    on: {
      "change": [function($event) {
        _vm.checkedType = "bagging"
      }, _vm.checkField]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "bagging"
    }
  }, [_vm._v("Default")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 radio"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedType),
      expression: "checkedType"
    }],
    attrs: {
      "type": "radio",
      "name": "directbagging",
      "id": "directbagging",
      "value": "directbagging"
    },
    domProps: {
      "checked": _vm._q(_vm.checkedType, "directbagging")
    },
    on: {
      "change": [function($event) {
        _vm.checkedType = "directbagging"
      }, _vm.checkField]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "directbagging"
    }
  }, [_vm._v("Direct (Heavies)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 radio"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedType),
      expression: "checkedType"
    }],
    attrs: {
      "type": "radio",
      "name": "sorterbagging",
      "id": "sorterbagging",
      "value": "sorterbagging"
    },
    domProps: {
      "checked": _vm._q(_vm.checkedType, "sorterbagging")
    },
    on: {
      "change": [function($event) {
        _vm.checkedType = "sorterbagging"
      }, _vm.checkField]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "sorterbagging"
    }
  }, [_vm._v("Sorter Based")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.BagLoading
    },
    on: {
      "update:active": function($event) {
        _vm.BagLoading = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onGenerateBagin()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Connection Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-signs'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.connectionTypeList,
      "selected-option": _vm.connectionTypeItem,
      "name": "Connection Type",
      "placeholder": "Select Connection"
    },
    on: {
      "select": _vm.selectConnectionType
    },
    model: {
      value: (_vm.connectionType),
      callback: function($$v) {
        _vm.connectionType = $$v
      },
      expression: "connectionType"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Connection Type')),
      expression: "errors.has('Connection Type')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Connection Type')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bag")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.bagData,
      "selected-option": _vm.bagObjData,
      "name": "Bag",
      "placeholder": "Select Bag"
    },
    on: {
      "select": _vm.selectedBag
    },
    model: {
      value: (_vm.bag),
      callback: function($$v) {
        _vm.bag = $$v
      },
      expression: "bag"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Bag')),
      expression: "errors.has('Bag')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Bag')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bag Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.bagTypeData,
      "selected-option": _vm.bagTypeObjData,
      "name": "Bag Type",
      "placeholder": "Select Bag Type"
    },
    on: {
      "select": _vm.selectedBagType
    },
    model: {
      value: (_vm.bagType),
      callback: function($$v) {
        _vm.bagType = $$v
      },
      expression: "bagType"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Bag Type')),
      expression: "errors.has('Bag Type')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Bag Type')))])], 1)], 1), _vm._v(" "), (_vm.bagType == 'MasterBag') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bag SubType")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.bagSubTypeData,
      "selected-option": _vm.bagSubTypeObjData,
      "name": "Bag SubType",
      "placeholder": "Select Bag SubType"
    },
    on: {
      "select": _vm.selectedBagSubType
    },
    model: {
      value: (_vm.bagSubType),
      callback: function($$v) {
        _vm.bagSubType = $$v
      },
      expression: "bagSubType"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Bag SubType')),
      expression: "errors.has('Bag SubType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Bag SubType')))])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.seviceCenterBagging) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Connection")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.connectionData,
      "selected-option": _vm.connectionObjData,
      "name": "Connection",
      "placeholder": "Select Connection"
    },
    on: {
      "select": _vm.selectedConnection
    },
    model: {
      value: (_vm.connection),
      callback: function($$v) {
        _vm.connection = $$v
      },
      expression: "connection"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Connection')),
      expression: "errors.has('Connection')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Connection')))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Destination Hub")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.destinationHubData,
      "selected-option": _vm.destinationHubObjData,
      "name": "Destination Hub",
      "placeholder": "Select Destination Hub",
      "disabled": _vm.seviceCenterBagging
    },
    on: {
      "select": _vm.selectedDestinationHub
    },
    model: {
      value: (_vm.destinationHub),
      callback: function($$v) {
        _vm.destinationHub = $$v
      },
      expression: "destinationHub"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Destination Hub')),
      expression: "errors.has('Destination Hub')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Destination Hub')))])], 1), _vm._v(" "), (_vm.destinationHubObjData.isbaggingpattern == true) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Route Mode")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "isDisabled": _vm.isDisabledRouteMode,
      "options": _vm.routeModeData,
      "selected-option": _vm.routeModeObjData,
      "name": "Route Mode",
      "placeholder": "Select Route Mode"
    },
    on: {
      "select": _vm.selectedRouteMode
    },
    model: {
      value: (_vm.routeMode),
      callback: function($$v) {
        _vm.routeMode = $$v
      },
      expression: "routeMode"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Route Mode')),
      expression: "errors.has('Route Mode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Route Mode')))])], 1) : _vm._e(), _vm._v(" "), (_vm.barcodeinput) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Bag Seal Number")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagSealNumber),
      expression: "bagSealNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Bag Seal Number",
      "name": "Bag Seal Number",
      "id": "bagsealno",
      "maxlength": "20",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.bagSealNumber)
    },
    on: {
      "keypress": function($event) {
        return _vm.checkBarcode(1)
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagSealNumber = $event.target.value
      }
    }
  }, 'input', _vm.colorCodeClassIcon(_vm.colorCodeBag, _vm.colorIconBag), false))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Bag Seal Number')),
      expression: "errors.has('Bag Seal Number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Bag Seal Number')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorBagSealNo),
      expression: "errorBagSealNo"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errorBagSealNo))])], 1) : _vm._e(), _vm._v(" "), (!_vm.barcodeinput) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Bag Seal Number")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagSealNumber),
      expression: "bagSealNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Bag Seal Number",
      "name": "Bag Seal Number",
      "id": "bagsealno",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.bagSealNumber)
    },
    on: {
      "click": _vm.scanBagSealNumber,
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagSealNumber = $event.target.value
      }
    }
  }, 'input', _vm.colorCodeClassIcon(_vm.colorCodeBag, _vm.colorIconBag), false))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Bag Seal Number')),
      expression: "errors.has('Bag Seal Number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Bag Seal Number')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorBagSealNo),
      expression: "errorBagSealNo"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errorBagSealNo))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bag == 'ChildBag'),
      expression: "bag=='ChildBag'"
    }],
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": "1",
      "unchecked-value": "0"
    },
    on: {
      "change": function($event) {
        return _vm.isAllowXbSeriesCheck($event)
      }
    },
    model: {
      value: (_vm.IsAllowXbSeries),
      callback: function($$v) {
        _vm.IsAllowXbSeries = $$v
      },
      expression: "IsAllowXbSeries"
    }
  }, [_vm._v("IsAllow XB Series (Child Bag)")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('b-button', {
    staticClass: "common-secondary-btn",
    staticStyle: {
      "margin-bottom": "4px"
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.flagGerateBag == true
    }
  }, [_vm._v("Generate")]), _vm._v(" "), _c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.searchBag()
      }
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.resetBaginProcess()
      }
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bagNoError),
      expression: "bagNoError"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.bagNoError))]), _vm._v(" \n                  "), _c('label', [_vm._v("Scanner Input ")]), _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    attrs: {
      "size": "sm",
      "id": "scannerinput",
      "type": "checkbox"
    },
    on: {
      "change": _vm.scannerinput
    }
  }), _c('span', {
    staticClass: "slider round"
  })])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("Bag No : ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 bagin-dtl"
  }, [_vm._v(_vm._s(_vm.baginBagNo))])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("Bag Status : ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 bagin-dtl"
  }, [_vm._v(_vm._s(_vm.baginBagStatus))])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("Bag Type : ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 bagin-dtl"
  }, [_vm._v(_vm._s(_vm.baginBagType))])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.bagInscan.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("AWB/Bag#")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbBag),
      expression: "awbBag"
    }],
    ref: "awbBag",
    class: {
      'form-control': true, 'error': _vm.errors.has('awbBag')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter AWB/Bag#",
      "name": "awbBag",
      "autocomplete": "off",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.awbBag)
    },
    on: {
      "keypress": function($event) {
        return _vm.validateBarcode($event)
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbBag = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.awbBagErr),
      expression: "awbBagErr"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.awbBagErr))]), _vm._v(" "), (_vm.showIconInput && _vm.shipmentForColor) ? _c('b-form-fieldset', {
    staticStyle: {
      "margin-top": "2%"
    }
  }, [_c('b-input-group', _vm._b({}, 'b-input-group', _vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon), false), [_vm._v(_vm._s(_vm.shipmentForColor))])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "35px"
    }
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.baginBagNo == false
    }
  }, [_vm._v("In Scan")]), _vm._v(" "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.resetInSacn()
      }
    }
  }, [_vm._v("Reset")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "-common-secondary mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openShipmentModel()
      }
    }
  }, [_vm._v("Search Shipment")]), _vm._v(" "), _c('b-button', {
    staticClass: "--common-secondary",
    staticStyle: {
      "margin-top": "-5px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.flagUpdateSealNo == false
    },
    on: {
      "click": function($event) {
        return _vm.openBagSealNoModel()
      }
    }
  }, [_vm._v("Update Bag Seal No")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("Close Bag")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 mt-2"
  }, [_c('label', [_vm._v("Weight")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.weight),
      expression: "weight"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('weight')
    },
    attrs: {
      "type": "text",
      "placeholder": "Weight",
      "name": "weight",
      "maxlength": "20",
      "disabled": _vm.weight < 201
    },
    domProps: {
      "value": (_vm.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.weight = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('weight')),
      expression: "errors.has('weight')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('weight')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 mt-2"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('b-button', {
    staticClass: "common-secondary-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.baginBagNo == '' || _vm.weight == ''
    },
    on: {
      "click": function($event) {
        return _vm.closeBag()
      }
    }
  }, [_vm._v("Close Bag")])], 1)], 1)], 1)]), _vm._v(" "), (_vm.BagForColor) ? _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('b-form-fieldset', [_c('b-input-group', _vm._b({}, 'b-input-group', _vm.colorCodeClassIcon(_vm.colorCodeBag, _vm.colorIconBag), false), [_vm._v(_vm._s(_vm.BagForColor))])], 1)], 1) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-tabs', {
    staticStyle: {
      "border": "1px solid #cecece"
    },
    attrs: {
      "content-class": "mt-3"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Open Bag List",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.loadOpenBagList()
      }
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "300px",
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "bagin-dtl"
  }, [_vm._v("Total Open Bags " + _vm._s(_vm.openBagHubName) + " : (" + _vm._s(_vm.openbagList.length) + ")")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "16px",
      "float": "right"
    },
    on: {
      "click": function($event) {
        return _vm.openBagList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this open bag list"
    }
  })]), _vm._v(" "), _c('table', {
    staticClass: "b-table table table-bordered"
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("Bag No.")]), _vm._v(" "), _c('th', [_vm._v("Bag Type")]), _vm._v(" "), _c('th', [_vm._v("Created Date")]), _vm._v(" "), _c('th', [_vm._v("Child Bags")]), _vm._v(" "), _c('th', [_vm._v("Shipments")])])]), _vm._v(" "), _c('tbody', [(_vm.openbagList.length > 0) ? _vm._l((_vm.openbagList), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.bagno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.bagtype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(row.createddate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.childbags))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.shipments))])])
  }) : [_c('tr', [_c('td', {
    attrs: {
      "colspan": "5",
      "align": "center"
    }
  }, [_vm._v("No record found")])])]], 2)])])])]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Pending List",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.loadPendingList()
      }
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "300px",
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "16px",
      "float": "right"
    },
    on: {
      "click": _vm.openPendingList
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this Pending list"
    }
  })]), _vm._v(" "), _c('table', {
    staticClass: "b-table table table-bordered"
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Normal")]), _vm._v(" "), _c('th', [_vm._v("High Value")]), _vm._v(" "), _c('th', [_vm._v("Reverse Pickup")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.pendingList), function(row, index) {
    return (_vm.pendingList.length > 0) ? [_c('tr', {
      class: {
        viewdata: _vm.viewdata.includes(index)
      }
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.clientid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showClientShipments(row, 'totalshipmentcount', index)
        }
      }
    }, [_vm._v(_vm._s(row.totalshipmentcount))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showClientShipments(row, 'normalshipment', index)
        }
      }
    }, [_vm._v(_vm._s(row.normalshipment))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showClientShipments(row, 'highvalueshipment', index)
        }
      }
    }, [_vm._v(_vm._s(row.highvalueshipment))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showClientShipments(row, 'reversepickupshipmentcount', index)
        }
      }
    }, [_vm._v(_vm._s(row.reversepickupshipmentcount))])])])] : _vm._e()
  }), _vm._v(" "), (_vm.pendingList.length != 0) ? [_c('tr', [_c('td', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v(_vm._s(_vm.totalshipmentcount))])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v(_vm._s(_vm.normalshipmentcount))])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v(_vm._s(_vm.highvalueshipmentcount))])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v(_vm._s(_vm.reversepickupshipmentcount))])])])] : [_c('tr', [_c('td', {
    attrs: {
      "colspan": "5",
      "align": "center"
    }
  }, [_vm._v("No record found")])])]], 2)])])])]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Inscan List"
    },
    on: {
      "click": function($event) {
        return _vm.loadBagInShipmentList()
      }
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "300px",
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "bagin-dtl"
  }, [_vm._v("Total Bag Shipments : (" + _vm._s(_vm.inScanList.length) + ")")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "16px",
      "float": "right"
    },
    on: {
      "click": function($event) {
        return _vm.loadBagInShipmentList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this inscan list"
    }
  })]), _vm._v(" "), _c('table', {
    staticClass: "b-table table table-bordered"
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("Shipment ID")]), _vm._v(" "), _c('th', [_vm._v("Shipment Status")]), _vm._v(" "), _c('th', [_vm._v("Volumetric Weight")]), _vm._v(" "), _c('th', [_vm._v("Physical Weight")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [(_vm.inScanList.length > 0) ? _vm._l((_vm.inScanList), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.shippingid != null ? row.shippingid : row.bagno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.volumetricweight))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.physicalweight))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-times-circle",
      staticStyle: {
        "cursor": "pointer",
        "font-size": "18px"
      },
      on: {
        "click": function($event) {
          return _vm.removeShipment(row.shippingid != null ? row.shippingid : row.bagno)
        }
      }
    })])])
  }) : [_c('tr', [_c('td', {
    attrs: {
      "colspan": "6",
      "align": "center"
    }
  }, [_vm._v("No record found")])])]], 2)])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("Sticker Print")]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("Bag No for Sticker Print : "), _c('span', {
    staticClass: "bagin-dtl"
  }, [_vm._v(_vm._s(_vm.printBagStickerNo))])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-button', {
    staticClass: "--common-secondary",
    attrs: {
      "type": "button",
      "disabled": _vm.printBagStickerNo == false
    },
    on: {
      "click": _vm.loadBagDetails
    }
  }, [_vm._v("Print Bag Sticker-A4")])], 1)])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.closeShipmentModel = false
      }
    },
    model: {
      value: (_vm.showShipmentModel),
      callback: function($$v) {
        _vm.showShipmentModel = $$v
      },
      expression: "showShipmentModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Search Shipment Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeShipmentModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.serachShipmentDetails.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Shipping Id : ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingId),
      expression: "shippingId"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Shipping Id",
      "name": "shippingId",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.shippingId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingId = $event.target.value
      }
    }
  }, 'input', _vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon), false))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shippingIdErrors),
      expression: "shippingIdErrors"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.shippingIdErrors))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "common-success mr-2",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.resetShipmentDetails()
      }
    }
  }, [_vm._v("Reset")])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-4"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("Destination")]), _vm._v(" "), _c('th', [_vm._v("Process Code")]), _vm._v(" "), _c('th', [_vm._v("Connection")]), _vm._v(" "), _c('th', [_vm._v("Parent LH Hub")]), _vm._v(" "), _c('th', [_vm._v("Group Name")]), _vm._v(" "), _c('th', [_vm._v("Group Number")]), _vm._v(" "), _c('th', [_vm._v("Route Mode")]), _vm._v(" "), _c('th', [_vm._v("Service Type")]), _vm._v(" "), (_vm.mpsIdPresent === true) ? _c('th', [_vm._v("MpsId")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.shipmentDetailsList.length > 0) ? _vm._l((_vm.shipmentDetailsList), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.destinationname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.processCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.connectionname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.parenthubname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.groupname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.groupno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.routemode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.servicetype))]), _vm._v(" "), (_vm.mpsIdPresent === true) ? _c('td', [_vm._v(_vm._s(row.mpsId))]) : _vm._e()])
  }) : [_c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v("No record found")])])]], 2)])])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.closeBagSealNoModel = false
      }
    },
    model: {
      value: (_vm.showBagSealNoModel),
      callback: function($$v) {
        _vm.showBagSealNoModel = $$v
      },
      expression: "showBagSealNoModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Update Bag Seal No.")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeBagSealNoModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Seal Changed Reason : ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason),
      expression: "reason"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "reason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.reason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Reason")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Seal Broken while Bag Close"
    }
  }, [_vm._v("Seal Broken while Bag Close")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Seal Broken While Packing"
    }
  }, [_vm._v("Seal Broken While Packing")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Seal Damage"
    }
  }, [_vm._v("Seal Damage")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SealNo not Readable"
    }
  }, [_vm._v("SealNo not Readable")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reasonErr),
      expression: "reasonErr"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.reasonErr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Old Bag Seal No: ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldSealNo),
      expression: "oldSealNo"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "disabled": true,
      "placeholder": "Old Bag Seal No",
      "name": "oldSealNo",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.oldSealNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldSealNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.oldSealNoErr),
      expression: "oldSealNoErr"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.oldSealNoErr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("New Bag Seal No: ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSealNo),
      expression: "newSealNo"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "New Bag Seal No",
      "name": "newSealNo",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.newSealNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newSealNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newSealNoErr),
      expression: "newSealNoErr"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.newSealNoErr))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updateBagSealNo()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.resetModalFields
    }
  }, [_vm._v("Reset")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.childbagConfirmationModel),
      callback: function($$v) {
        _vm.childbagConfirmationModel = $$v
      },
      expression: "childbagConfirmationModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v("Child bags should only be created with PLS series.")]), _vm._v(" "), _c('p', [_vm._v("Are you sure you want to create the child bag with XB series?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.continueChildBagTrue
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.cancelChildBagConModal
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.PendingListModal),
      callback: function($$v) {
        _vm.PendingListModal = $$v
      },
      expression: "PendingListModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Shipment Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeShipmentList
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('b-card', {
    staticStyle: {
      "margin": "15px",
      "-webkit-box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)",
      "-moz-box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)",
      "box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding": "0.25rem !important"
    }
  }, [_c('table', {
    staticClass: "table-bordered table",
    staticStyle: {
      "position": "relative",
      "overflow": "auto",
      "font-size": "12px"
    }
  }, [_c('thead', {
    staticClass: "table table-bordered mytable12 poform_tableheader"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v("Drop Pincode")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v("Final Destination ID")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v("Vol.Weight")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v("Phy.Weight")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v("Declared Value")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v("Order Type")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v("Service Type")])])]), _vm._v(" "), _vm._l((_vm.ClientWiseShipmentDetails), function(data, ind) {
    return (_vm.ClientWiseShipmentDetails.length > 0) ? _c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.droppincode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.finaldestinationid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.volweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.phyweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.declaredvalue))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ordertype))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.servicetype))])])]) : _vm._e()
  }), _vm._v(" "), (_vm.ClientWiseShipmentDetails.length == 0) ? _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("No record found")])])]) : _vm._e()], 2)])], 1)], 1)])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.invalidTokenModal),
      callback: function($$v) {
        _vm.invalidTokenModal = $$v
      },
      expression: "invalidTokenModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.invalidtokenmsg))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_vm._v("Cancel")])])])])])], 1)]), _vm._v(" "), (_vm.showMultipartShipmentModal == true) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Pending Shipment List"
    },
    model: {
      value: (_vm.showMultipartShipmentModal),
      callback: function($$v) {
        _vm.showMultipartShipmentModal = $$v
      },
      expression: "showMultipartShipmentModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Pending Shipment List")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeMutlipartModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Multi Shipment Group Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Current Hub")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.multipartShipmentDetails), function(data, index) {
    return (_vm.multipartShipmentDetails.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShippingId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShipmentStatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.MultiShipmentGroupId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.CurrentHubID))])]) : _vm._e()
  }), 0)])])])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.XBSealModel),
      callback: function($$v) {
        _vm.XBSealModel = $$v
      },
      expression: "XBSealModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Update Seal")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeXBSealModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('span', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.IsAllowXBSeal),
      expression: "IsAllowXBSeal"
    }],
    attrs: {
      "type": "checkbox",
      "id": "IsAllowXBSeal",
      "value": "IsAllowXBSeal"
    },
    domProps: {
      "checked": Array.isArray(_vm.IsAllowXBSeal) ? _vm._i(_vm.IsAllowXBSeal, "IsAllowXBSeal") > -1 : (_vm.IsAllowXBSeal)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.IsAllowXBSeal,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "IsAllowXBSeal",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.IsAllowXBSeal = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.IsAllowXBSeal = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.IsAllowXBSeal = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check",
    staticStyle: {
      "cursor": "pointer"
    }
  })])]), _c('label', {
    attrs: {
      "for": "IsAllowXBSeal"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('b', {
    staticStyle: {
      "color": "red",
      "margin-left": "-4%"
    }
  }, [_vm._v(_vm._s(_vm.XBSealMsg))])])]), _vm._v(" "), (_vm.IsAllowXBSeal == true) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Select Reason : ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.xbsealreason),
      expression: "xbsealreason"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "Reason"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.xbsealreason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.clearXBReasonError]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select Reason")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SealNotAvailable"
    }
  }, [_vm._v("Seal not available")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SealBroken"
    }
  }, [_vm._v("Seal Broken")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.xbsealreasonErr),
      expression: "xbsealreasonErr"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.xbsealreasonErr))])], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.generateBag('IsXbSeal')
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeXBSealModel
    }
  }, [_vm._v("No")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation",
      "no-close-on-backdrop": true,
      "no-close-on-esc": true
    },
    model: {
      value: (_vm.childbagCrossBorderConfirmationModel),
      callback: function($$v) {
        _vm.childbagCrossBorderConfirmationModel = $$v
      },
      expression: "childbagCrossBorderConfirmationModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.closeBagEvent == 1),
      expression: "closeBagEvent == 1"
    }]
  }, [_vm._v("This shipment needs to be travelled via air. Please add this child bag into parent air bag having XB seal.")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.closeBagEvent == 2),
      expression: "closeBagEvent == 2"
    }]
  }, [_vm._v("Please wrap \""), _c('strong', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("Green Color")]), _vm._v("\" tape around cross border bag and seal.")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.closeBagEvent == 2),
      expression: "closeBagEvent == 2"
    }]
  }, [_vm._v("कृपया \""), _c('strong', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("हरा रंग")]), _vm._v("\" टेप को सीमा पार बैग के चारों ओर लपेटें और सील करें।")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.closeBagEvent == 3),
      expression: "closeBagEvent == 3"
    }]
  }, [_vm._v("Please wrap \""), _c('strong', {
    staticStyle: {
      "color": "yellow"
    }
  }, [_vm._v("Yellow Color")]), _vm._v("\" tape around document bag and seal.")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.closeBagEvent == 3),
      expression: "closeBagEvent == 3"
    }]
  }, [_vm._v("कृपया \""), _c('strong', {
    staticStyle: {
      "color": "yellow"
    }
  }, [_vm._v("पीला रंग")]), _vm._v("\" टेप को दस्तावेज़ बैग के चारों ओर लपेटें और सील करें।")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.childbagCrossBorderConfirmationModel = false
      }
    }
  }, [_vm._v("OK")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.shipmentDestChangedConfirmationModal),
      callback: function($$v) {
        _vm.shipmentDestChangedConfirmationModal = $$v
      },
      expression: "shipmentDestChangedConfirmationModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeDestModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.shipmentDestMsg))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.changeBagDestination
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeShipmentDestModal
    }
  }, [_vm._v("No")])])])])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cacfbf9a","hasScoped":true}!./src/views/components/BaginProcess/BaginProcess.html
// module id = 948
// module chunks = 2